module.exports = "/_next/static/images/features-content-808274f15290e36a1d7822632ebf5b41.png";